import useMarkNotificationAsRead from "api/Notifications/useMarkNotificationAsRead";

/**
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.link
 * @param {string} props.message
 * @param {boolean} props.was_read
 * @param {Array} props.payload
 * @param {string} props.created_at
 * @param {string} props.id
 * @param {string} props.ago
 * @param {Function} props.onClose
 * @returns {JSX.Element}
 */
const NotificationItem = (props) => {
	const { title, link, message, id, onClose, ago, was_read } = props;

	const { mutateAsync: markAsRead } = useMarkNotificationAsRead(id);

	const handleNotificationClick = async () => {
		if (!was_read) {
			await markAsRead({ id });
		}

		onClose();

		if (link) {
			window.location.href = link;
		}
	};

	return (
		<button
			type="button"
			className={`w-full text-left px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm border-b last:border-b-0 flex flex-col gap-1 ${
				was_read ? "bg-white" : "bg-blue-50/50"
			}`}
			onClick={handleNotificationClick}
		>
			<div className="font-bold flex items-center justify-between gap-2">
				<div className="flex items-center gap-2 min-w-0">
					{!was_read && <span className="h-2 w-2 rounded-full bg-blue-500 flex-shrink-0" />}
					<span className="truncate">{title}</span>
				</div>
				<span className="text-xs text-gray-500 flex-shrink-0">{ago}</span>
			</div>
			<span className="text-gray-500 truncate">{message}</span>
		</button>
	);
};

export default NotificationItem;
